import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { indexMap } from '@helpers'
import NavigationLink from './NavigationLink'
import './MobileNavigation.module.scss'

const renderLinks = (data, click) =>
  indexMap((item, index) => (
    <NavigationLink key={`${R.path(['link', 'slug'], item)}-${index}`} item={item} click={() => click()} />
  ))(data)

const MobileNavigation = ({ links, click }) => (
  <nav>
    <ul styleName='list'>{renderLinks(links, click)}</ul>
  </nav>
)

MobileNavigation.propTypes = {
  links: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowSubmenu: PropTypes.bool,
  click: PropTypes.func
}

MobileNavigation.defaultProps = {
  allowSubmenu: false,
  click: () => {}
}

export default MobileNavigation



// WEBPACK FOOTER //
// ./src/components/MobileDropdown/MobileNavigation/MobileNavigation.js